import React, { useState, useEffect } from "react";
import Navbar from "../../../Navbar";
import Sidebar from "../../../Sidebar";
import { listAllCompanies, renewCompanySubscription } from "../../../services/CompanyService";
import { CDBTable, CDBSpinner } from "cdbreact";
import EmpresaForm from "./EmpresaForm";
import EditarEmpresa from "./EditarEmpresa";
import PaginationBootstrap from "../../../components/PaginationBootstrap";
import { maskCNPJ } from "../../../util/StringUtils";
import dayjs from "dayjs";
import { toast } from "react-toastify";

export const Empresas = () => {
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [filtroNome, setFiltroNome] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    handleSidebarToggle();
    setIsLoading(true);
    listCompanies();
  }, []);

  function listCompanies(delay) {
    listAllCompanies(delay)
      .then((response) => {
        setCompanies(response);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }

  function handleSidebarToggle() {
    if (window.innerWidth <= 720) setToggled(true);
  }

  function renewCompanyAccess(companyId) {
    const confirmRenewal = window.confirm("Tem certeza que deseja renovar o acesso desta empresa?");
    if (confirmRenewal) {
      renewCompanySubscription(companyId).then(() => {
        toast.success("Acesso da empresa renovado com sucesso!");
        listCompanies();
      })
        .catch(() => {
          toast.error("Ocorreu um erro ao renovar o acesso da empresa.");
        });
    }
  }

  return (
    <div className="d-flex">
      {/* 1. Wrapper da Sidebar padronizado */}
      <div>
        <Sidebar toggled={toggled} />
      </div>

      {/* 2. Main Content Wrapper */}
      <div className="main-content-wrapper">
        <Navbar toggled={toggled} setToggled={setToggled} />
        
        {/* 3. Wrapper de Altura 100% */}
        <div style={{ height: "100%" }}>
          {/* 4. Grid Container com padding padrão Alcon */}
          <div style={{ padding: "20px 5%" }}>
            <div>
              <div className="mt-3">
                
                {/* 5. Header unificado e alinhado (Título + Ação Principal) */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h3 className="fw-bold text-dark mb-0">Empresas</h3>
                  <EmpresaForm listCompanies={listCompanies} />
                </div>
                
                {/* BARRA DE FERRAMENTAS: BUSCA */}
                <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mb-4">
                  <div className="col-12 col-md-5">
                    <div className="position-relative shadow-sm rounded-3 overflow-hidden border bg-white">
                      <i className="fas fa-search position-absolute text-muted" style={{ left: '15px', top: '17px' }}></i>
                      <input
                        type="text"
                        className="form-control border-0 ps-5 shadow-none"
                        style={{ height: "50px", fontSize: "1rem" }}
                        placeholder="Buscar pelo nome fantasia..."
                        value={filtroNome}
                        onChange={(e) => setFiltroNome(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* 6. Validação de Carregamento e renderização limpa de tabela + paginação */}
                {isLoading ? (
                  <div className="d-flex justify-content-center p-5">
                    <CDBSpinner dark />
                  </div>
                ) : (
                  <>
                    <div className="card border-0 shadow-sm rounded-4 p-3">
                      <CDBTable className="alcon-table" responsiveSm borderless>
                        <thead>
                          <tr>
                            <th>Empresa</th>
                            <th>CPF/CNPJ</th>
                            <th className="text-center">Status</th>
                            <th>Vencimento</th>
                            <th className="text-end px-4">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {companies && companies
                            .filter((company) => {
                              const busca = filtroNome.toLowerCase();
                              const nomeFantasia = company.fantasyName?.toLowerCase() || "";

                              const documentoNoBanco = company.documentNumber?.replace(/\D/g, "") || "";
                              const buscaApenasNumeros = busca.replace(/\D/g);

                              return (
                                nomeFantasia.includes(busca) ||
                                (buscaApenasNumeros !== "" && documentoNoBanco.includes(buscaApenasNumeros))
                              );
                            })
                            .map((company) => (
                              <tr key={company.id}>
                                <td>
                                  <div className="fw-bold text-dark">{company.fantasyName}</div>
                                  <div className="text-muted small opacity-75" style={{ fontSize: '0.65rem' }}>
                                    ID: {String(company.id).substring(0, 8)}
                                  </div>
                                </td>

                                <td className="text-muted small">
                                  {maskCNPJ(company.documentNumber ?? "")}
                                </td>

                                <td className="text-center">
                                  <span className={`badge rounded-pill ${company.active ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`} style={{ fontSize: '0.75rem', padding: '0.5em 1.2em' }}>
                                    {company.active ? "ATIVA" : "INATIVA"}
                                  </span>
                                </td>

                                <td className="text-muted small">
                                  <div className="fw-bold text-dark">{dayjs(company.subscriptionEndDate).format("DD/MM/YYYY")}</div>
                                  <div className="extra-small" style={{ fontSize: '0.65rem' }}>
                                    {dayjs(company.subscriptionEndDate).diff(dayjs(), 'day')} dias restantes
                                  </div>
                                </td>

                                <td className="text-end px-4">
                                  <div className="d-flex align-items-center justify-content-end">
                                    <button
                                      onClick={() => renewCompanyAccess(company.id)}
                                      className="btn btn-sm btn-outline-success fw-semi-bold rounded-3 me-3 px-3 d-flex align-items-center gap-1"
                                      style={{ fontSize: '0.75rem', padding: '0.4rem 0.8rem' }}
                                    >
                                      <i className="fas fa-sync-alt"></i> Renovar Assinatura
                                    </button>

                                    <div className="dropdown position-static">
                                      <button
                                        className="btn btn-link btn-3-dots text-muted shadow-none p-0"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fas fa-ellipsis-v"></i>
                                      </button>
                                      <ul className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3">
                                        <li>
                                          <EditarEmpresa company={company} listCompanies={listCompanies} />
                                        </li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li>
                                          <button className="dropdown-item py-2 d-flex align-items-center text-danger">
                                            <i className="fas fa-ban me-2"></i> Bloquear Acesso
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </CDBTable>
                    </div>

                    {/* Paginação encapsulada sob o fragmento seguro */}
                    <div className="mt-4 d-flex justify-content-between align-items-center">
                      <span className="text-muted small fw-bold">{companies.length} registros</span>
                      <PaginationBootstrap pageInfo={{ totalPages: 1, currentPage: 1 }} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Empresas;